import React from 'react';
import style from './style.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const GoBackButton = ({ label = 'Go Back' }) => {
    return (
        <>
            <button className={style.backButton} onClick={() => window.history.back()}>
                <FontAwesomeIcon icon={"arrow-left"} />
                <span>{label}</span>
            </button>
        </>
    );
};

export default GoBackButton;